define(
    'LNRS/Components/Charts/legend',["jquery", "d3", "scrollMagic", "mustache", "LNRS/Components/Charts/Base"],
    function ($, d3, ScrollMagic, mustache, Base) {
        "use strict";

        function Legend(scope, labels, colors, id) {
            Base.call(this, scope,
                {
                    legendLabels:labels,
                    colors: colors
                }, id);
        }

        Legend.prototype = Object.create(Base.prototype);

        return function initLegend(args) {
            return args.IsExperienceEditorEditing ? null : new Legend(
                args.scope,
                args.labels,
                args.colors,
                args.id);
        };
    });
